import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormClassicRoute: InvariantJiraRoute = {
	name: 'software-form-classic',
	path: '/jira/software/c/projects/:projectKey/form',
	exact: true,
};
